
export default class Filter {
    
    static get selector() {
        return '.filter';
    }

    constructor(el) {
        //return;
        this.el = el;
        this.button = document.querySelector('.header__filterButton');
        this.isOpen = false;
        this.cities = this.getCities();
        this.submitButton = this.el.querySelector('.filter__action--submit');
        this.resetButton = this.el.querySelector('.filter__action--reset');
        this.closeButton = this.el.querySelector('.filter__headerClose');
        this.headerTitle = this.el.querySelector('.filter__headerTitle');
        this.select =  this.el.querySelector('.filter__select select');
        
        this.inputs = this.el.querySelectorAll('input');
        this.writersInputs = this.el.querySelectorAll('input[name="writers[]"]');

        this.toggleButton();
        this.setEvents();
        this.el.classList.add('filter--on');
        /*if(window.getComputedStyle(this.select, null).display != 'none'){
            this.writersInputs.forEach( input => {
                input.disabled = true;
            })
        }*/
    }

    /**
     * 
     */

    toggleButton() {
        let formData = new FormData(this.el);
        let temp = Array.from(formData.entries());
        let count = temp.length;
        
        if(count > 0) {
            this.submitButton.disabled = false;
            this.resetButton.disabled = false;
        }
        else{
            this.submitButton.disabled = true;
            this.resetButton.disabled = true;
        }
    }


    /**
     * Display/Hide Filters
     */

    toggleFilter() {
        if(this.isOpen) this.closeFilter();
        else this.openFilter();
    }

    openFilter() {
        this.el.classList.add('filter--active');
        this.button.classList.add('header__filterButton--active')
        window.document.documentElement.classList.add('filtersOpen');
        this.isOpen = true;
    }

    closeFilter() {
        this.el.classList.remove('filter--active');
        this.button.classList.remove('header__filterButton--active')
        window.document.documentElement.classList.remove('filtersOpen');
        this.isOpen = false;
    }

    /**
     * Cities
     */

    getCities() {
        let elCities = document.querySelectorAll('.filter__checkbox[name="cities[]"]');
        let cities = {};

        elCities.forEach(eCity => {
            cities[eCity.getAttribute('value')] = {
                el : eCity,
                isActive : eCity.checked,
                link : document.body.querySelector('a[data-filter-city="' + eCity.getAttribute('value') + '"]')
            }
        });
        
        return cities;
    }

    toggleCity(city) {
        if(!city.isActive) this.activateCity(city);
        else this.desactiveCity(city);
        window.dispatchEvent(new CustomEvent('vegout-closeMenu'));
        this.ajaxSubmit();
    }

    activateCity(city) {
        if(city.isActive) return;
        city.el.checked = true;
        city.link.classList.add('sideNav__subLink--active')
        city.isActive = true;
    }

    desactiveCity(city) {
        if(!city.isActive) return;
        city.el.checked = false;
        city.link.classList.remove('sideNav__subLink--active')
        city.isActive = false;
    }

    ajaxSubmit(url = null) {
        let formData = new FormData(this.el);
        url = this.createUrl(formData, url);

        window.location = url;

        /*window.dispatchEvent( new CustomEvent('vegout-redirect', {
            detail: {
              url: url
            }
        }));

        this.closeFilter();*/
    }

    createUrl(formData, url) {
        let params = new URLSearchParams(formData);
        let entries = params.entries();
        if(!url) url = this.el.action;
        if(Array.from(entries).length)  url += '?' + params.toString();
        return url;
    }

    updateButton() {
        let formData = new FormData(this.el);
        let temp = Array.from(formData.entries());
        let count = temp.length;
        if(count){
            this.button.dataset.countFilter = count;
            this.headerTitle.dataset.countFilter = count;
        } 
        else {
            delete this.button.dataset.countFilter;
            delete this.headerTitle.dataset.countFilter;
        }
        this.toggleButton();

    }

    reset() {
        Array.from(this.inputs).forEach(input => {
            input.checked = false;
        });
        this.select.selectedIndex = 0;
        this.updateButton();
        this.closeFilter();
        window.dispatchEvent( new CustomEvent('vegout-redirect', {
            detail: {
              url: this.el.action
            }
        }));
    }
    

    setEvents() {
        this.button.addEventListener('click', (e) => {  this.e_clickButton(e);  });
        this.resetButton.addEventListener('click', (e) => {  this.e_clickReset(e); });
        this.el.addEventListener('submit', this.e_submit.bind(this) );
        window.addEventListener('vegout-submit-url', this.e_submit_url.bind(this) );
        window.addEventListener('vegout-filter-update', this.e_update_filter.bind(this) );
        window.addEventListener('vegout-filter-close', this.e_close.bind(this) );

        Object.keys(this.cities).forEach(key => {
            this.cities[key].link.addEventListener('click', (e) => { this.e_clickCities(e, this.cities[key]); });
        });

        Array.from(this.inputs).forEach(input => {
            input.addEventListener('change', this.e_change.bind(this) );
        });
        this.closeButton.addEventListener('click', (e) => {  this.e_closeButton(e);  });

    }

    e_clickButton(e) {
        e.preventDefault();
        this.toggleFilter();
    }

    e_close(e) {
        this.closeFilter();
    }

    e_closeButton(e) {
        e.preventDefault();
        this.closeFilter();
    }

    e_clickReset(e) {
        e.preventDefault();
        e.target.blur();
        this.reset();
    }

    e_clickCities(e, city) {
        e.preventDefault();
        e.target.blur();
        this.toggleCity(city);
    }

    e_change(e) {
        this.toggleButton()
        //this.updateButton();
    }

    e_update_filter() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const entries = urlParams.entries();
        this.reset(); 
        
        for(const entry of entries) {
            let checkBox = this.el.querySelector('input[name="'+ entry[0] + '"][value="' + entry[1] + '"]');
            checkBox.checked = true;
        }
        
        this.updateButton();

    }

    e_submit(e) {
        e.preventDefault();
        this.ajaxSubmit();
        this.updateButton();
    }

    e_submit_url(e) {
        let url = e.detail.url;
        this.el.action = url;
        this.ajaxSubmit(url);
    }
}